/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordingManualChangesResponseFieldsRecordingVersionItemsInner
 */
export interface RecordingManualChangesResponseFieldsRecordingVersionItemsInner {
    /**
     * 
     * @type {string}
     * @memberof RecordingManualChangesResponseFieldsRecordingVersionItemsInner
     */
    op: string;
    /**
     * 
     * @type {object}
     * @memberof RecordingManualChangesResponseFieldsRecordingVersionItemsInner
     */
    value: object | null;
}

/**
 * Check if a given object implements the RecordingManualChangesResponseFieldsRecordingVersionItemsInner interface.
 */
export function instanceOfRecordingManualChangesResponseFieldsRecordingVersionItemsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "op" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function RecordingManualChangesResponseFieldsRecordingVersionItemsInnerFromJSON(json: any): RecordingManualChangesResponseFieldsRecordingVersionItemsInner {
    return RecordingManualChangesResponseFieldsRecordingVersionItemsInnerFromJSONTyped(json, false);
}

export function RecordingManualChangesResponseFieldsRecordingVersionItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingManualChangesResponseFieldsRecordingVersionItemsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'op': json['op'],
        'value': json['value'],
    };
}

export function RecordingManualChangesResponseFieldsRecordingVersionItemsInnerToJSON(value?: RecordingManualChangesResponseFieldsRecordingVersionItemsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'op': value.op,
        'value': value.value,
    };
}

